import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "home",
  "use": "home-usage",
  "viewBox": "0 0 14 13",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 13\" id=\"home\"><path d=\"M12.03 12.479v-5.03c0-.274.218-.438.492-.438h.984a.48.48 0 0 0 .437-.328.356.356 0 0 0-.11-.492L7.329.123c-.164-.164-.437-.164-.656 0L.166 6.191a.356.356 0 0 0-.11.492.48.48 0 0 0 .438.328h.984c.274 0 .492.164.492.438v5.03a.47.47 0 0 0 .438.437h9.184a.43.43 0 0 0 .438-.437\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol